//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/SelectBody.js";
import "../Assemblies/Assemblies.SelectComponent.js";
import "../no/SelectBodyList.js";
import "../no/SelectFaceList.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"ActionType",1,0],[0,"ChangeBoxSize",1,0],[1,"Clearance",0,"Expression",0],[1,"RegionFaces",0,"ScCollector",0],[0,"RemoveParameter",1,0],[1,"SelectBoundBox",0,"SelectBody",0],[1,"SelectLinkTarget",0,"Assemblies.SelectComponent",0],[1,"SheetBody",0,"SelectBodyList",0],[1,"TaggedFaces",0,"SelectFaceList",0],[0,"TrimDirection",1,0],[0,"Type",1,0]],[[[],"InsideBoundBox",{},0,0],[[],"InsideCrossBoundBox",{},0,0],[["block"],"SetBoundBox",{},1,0],[["block"],"SetManualBody",{},1,0],[[],"CreateBoundBox",{},0,0],[[],"CreateToolingBox",{R_:{boxBlock:"Body"}},0,0]],[]];
SPLM.Tooling.TrimSolidBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.TrimSolidBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.TrimSolidBuilder.Types = Object.freeze({
    "Face" : "Face", "SheetBody" : "SheetBody", "ManufacturingRegion" : "ManufacturingRegion"});

SPLM.Tooling.TrimSolidBuilder.TrimSolidAction = Object.freeze({
    "Trim" : "Trim", "Subtract" : "Subtract", "KeepBoxandRegion" : "KeepBoxandRegion"});

export default SPLM;